import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useBrands } from '../hooks/useBrands';

interface BrandContextType {
  currentBrandId: string | undefined;
  setCurrentBrandId: (id: string) => void;
}

const BrandContext = createContext<BrandContextType>({
  currentBrandId: undefined,
  setCurrentBrandId: () => {}
});

interface BrandProviderProps {
  children: ReactNode;
}

export const BrandProvider: React.FC<BrandProviderProps> = ({ children }) => {
  const [currentBrandId, setCurrentBrandId] = useState<string | undefined>(undefined);
  const { data: brandsData } = useBrands();

  useEffect(() => {
    // Set the first brand as default when brands are loaded
    if (!currentBrandId && brandsData && (brandsData as any).brands?.length > 0) {
      setCurrentBrandId((brandsData as any).brands[0].id);
    }
  }, [brandsData, currentBrandId]);

  return (
    <BrandContext.Provider value={{ currentBrandId, setCurrentBrandId }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrandContext = () => useContext(BrandContext); 